import { placeParamsToURL } from 'helpers/CommonHelper';
import { hasUserAccessFunctionality } from 'helpers/PermissionHelper';
import { t } from 'i18next';
import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

import type { MenuGroup } from './sidebarConfig';
import './../../assets/scss/adminSidebar.scss';

interface DarkSidebarProps {
  menu: MenuGroup[];
  width?: number;
  Header: any;
  Footer: any;
  collasped: boolean;
}

const DarkSidebar: React.FC<DarkSidebarProps> = ({
  menu,
  width = 270,
  Header,
  Footer,
  collasped,
}) => {
  const location = useLocation();
  const [openKey, setOpenKey] = useState<string | null>(null);

  // const getActiveParent = (): string | null => {
  //   for (const item of menu) {
  //     if (!item.children) continue;

  //     const hasActiveChild = item.children.some((child) => child.path === location.pathname);

  //     if (hasActiveChild) return item.key;
  //   }
  //   return null;
  // };
  const getActiveParent = (): string | null => {
    for (const group of menu) {
      for (const item of group.items) {
        if (!item.children) continue;

        const hasActiveChild = item.children.some((child: any) => child.path === location.pathname);

        if (hasActiveChild) return item.key;
      }
    }

    return null;
  };

  const getMenuItemPath = (menuItem: any) => {
    if (menuItem.tabRedirects) {
      const redirects = Array.isArray(menuItem.tabRedirects)
        ? menuItem.tabRedirects
        : Object.values(menuItem.tabRedirects);

      const firstAllowed = redirects.find((redirect: any) =>
        hasUserAccessFunctionality(redirect.permission || redirect.permissions)
      );
      if (firstAllowed) {
        return placeParamsToURL(firstAllowed.path);
      }
    }
    return menuItem.path ?? '';
  };

  const getMenuItemLabel = (menuItem: any) => {
    if (menuItem.tabRedirects) {
      const redirects = Array.isArray(menuItem.tabRedirects)
        ? menuItem.tabRedirects
        : Object.values(menuItem.tabRedirects);

      const allowedRedirects = redirects.filter((redirect: any) =>
        hasUserAccessFunctionality(redirect.permission || redirect.permissions)
      );
      if (allowedRedirects.length === 1) {
        const rawLabel = allowedRedirects[0].label;
        return rawLabel ? t(rawLabel) : menuItem.label;
      }
    }
    return menuItem.label;
  };

  const activeParent = getActiveParent();

  const toggleMenu = (key: string) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  // const handleSubmenuClick = (parentKey: string) => {
  //   if (openKey === parentKey) {
  //     setOpenKey(null);
  //   }
  // };
  return (
    <div
      className={`sidebar text-light d-flex flex-column dark-mode left-sidebar ${collasped ? 'sidebar-open' : 'sidebar-close'}`}
      style={{ width }}
    >
      <Header />
      <ul className="sidebar-menu list-unstyled flex-grow-1">
        {menu.map((group: MenuGroup) => {
          const visibleItems = group.items.filter((item) =>
            hasUserAccessFunctionality(item?.permission)
          );

          if (!visibleItems.length) return null;
          return (
            <React.Fragment key={group.title}>
              <li className="sidebar-title my-2">{group.title}</li>

              {visibleItems.map((item) => {
                const isRouteActive = activeParent === item.key;
                const isOpen = isRouteActive || openKey === item.key;
                const hasAccess = hasUserAccessFunctionality(item?.permission);
                if (!hasAccess) return null;

                return (
                  <li key={item.key}>
                    {item.path && (
                      <NavLink
                        to={getMenuItemPath(item)}
                        end
                        className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                        onClick={() => setOpenKey(null)}
                      >
                        <span className="active-icon d-flex align-items-center gap-2">
                          {item?.svgIcon} {getMenuItemLabel(item)}
                        </span>
                      </NavLink>
                    )}
                    {item.children && (
                      <>
                        <div
                          className={`sidebar-link sidebar-parent ${isRouteActive ? 'active' : ''}`}
                          onClick={() => toggleMenu(item.key)}
                        >
                          <span className="active-icon d-flex align-items-center gap-2">
                            {item?.svgIcon} {getMenuItemLabel(item)}
                          </span>
                          <span className={`sidebar-arrow ${isOpen ? 'open' : ''}`}>▾</span>
                        </div>

                        <Collapse in={isOpen}>
                          <ul className="sidebar-submenu list-unstyled">
                            {item.children.map((child) => (
                              <li key={child.key}>
                                <NavLink
                                  to={child.path}
                                  className={({ isActive }) =>
                                    `sidebar-sublink ${isActive ? 'active' : ''}`
                                  }
                                  // onClick={() => handleSubmenuClick(item.key)}
                                >
                                  {child.label}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </Collapse>
                      </>
                    )}
                  </li>
                );
              })}
            </React.Fragment>
          );
        })}
      </ul>
      <Footer />
    </div>
  );
};

export default DarkSidebar;
